import { Navigate, Route, Routes } from 'react-router';
import Layout from './components/Layout';
import Home from './pages/Home';
import Work from './pages/Work';
import Uses from './pages/Uses';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        {/* /about was the old alias for the home page — keep the URL alive. */}
        <Route path="about" element={<Navigate to="/" replace />} />
        <Route path="work" element={<Work />} />
        <Route path="uses" element={<Uses />} />
        <Route path="contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default App;
